export enum CurveTypes {
  Linear = 1,
  Cubic,
  Quadratic,
}
